module.exports = __webpack_public_path__ + "img/ms-authenticator.377f34e7.png";